export default "__VITE_ASSET__cf22480c__"